// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"2":"blogPost","239":"blog","443":"about","631":"contact"}[chunkId] || chunkId) + "." + {"2":"bb49f89d","239":"01a85af2","443":"5892910d","631":"a02495c2","897":"4a35e5cc"}[chunkId] + ".js";
};